<template>
  <div id="formBox" class="panel panel-primary page">

    <div class="panel-heading">
        <span class="panel-title">Change Password</span>
    </div>

    <form novalidate class="form-horizontal" role="form">
        <div class="panel-body">
            <div class="form-group">
                <input type="password" v-model="password" class="form-control" placeholder="New Password">
            </div>
            <div class="form-group">
                <input type="password" v-model="password_confirm" class="form-control" placeholder="Confirm Password">
            </div>
            {{ error }}
        </div> <!-- .panel-body -->

        <div class="panel-footer text-right">
            <button type="submit" class="btn btn-success" @click="send_reset">Change Password</button>
        </div>
    </form>
</div> <!-- #formBox -->
</template>

<style scoped>

</style>

<script>
  export default {
    data() {
      return {
        password: "",
        password_confirm: "",
        error: "",
      }
    },
    methods: {
      async send_reset() {
        let req = null;
        try {
          req = await (await this.$http.post("/api/reset/set/", {
            password: this.password,
            password_confirm: this.password_confirm,
            id: this.$route.params.reset_id,
          })).json();
        } catch (e) {
          this.error = (await e.json()).error;
          return;
        }
        if (req.success) {
          this.$store.commit("add_toast", {
            message: "Your password has been set."
          });
          this.$router.push({name: "login"});
        } else {
          this.error = "An unknown error occured."
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/PasswordReset.vue?34293fd1